import * as React from "react";
import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./MyTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faChevronDown,
    faInfo,
    faUser,
    faQuestionCircle,
} from "@fortawesome/pro-light-svg-icons";

const ListBox = ({
    data,
    selected,
    handleSelection,
    description = null,
    tooltip = null,
    icon = false,
    disabled = false,
    multiple = false,
    maxSelected = -1,
    action = (payload) => {},
    actionIcon = undefined,
    actionIconCalculate = undefined,
    widthFull = false,
    optionsAlwaysVisibles = false,
    warning = false,
    warningText = "",
    info = false,
    infoText = "",
    forceMaxHeight = false,
    isIconsList = false,
}) => {
    return (
        <div className={"flex " + (widthFull ? "w-full" : "")}>
            <Listbox
                value={selected}
                onChange={(e) => {
                    if (multiple && maxSelected !== -1) {
                        if (e?.length <= maxSelected) {
                            handleSelection(e);
                        } else {
                            //too many selected
                        }
                    } else {
                        handleSelection(e);
                    }
                }}
                disabled={disabled}
                multiple={multiple}
            >
                <div className={widthFull ? "w-full" : " w-fit"}>
                    {description && (
                        <div className="mt-1 flex flex-row">
                            <Listbox.Label className="mb-2 block truncate text-xs font-medium leading-6 text-gray-700">
                                {description}
                            </Listbox.Label>
                            {info && !warning && (
                                <Tooltip>
                                    <span className="ms-1">
                                        <TooltipTrigger type="button">
                                            <FontAwesomeIcon
                                                className="h-4 w-4 text-blue-400"
                                                icon={faQuestionCircle}
                                            />
                                        </TooltipTrigger>
                                    </span>
                                    <TooltipContent className="Tooltip">
                                        <span className="text-wrap max-w-[20px]">
                                            {infoText}
                                        </span>
                                    </TooltipContent>
                                </Tooltip>
                            )}
                        </div>
                    )}
                    <div className="relative">
                        <Listbox.Button
                            className={
                                "border-pagination-border relative min-h-[40px] min-w-[180px] cursor-default rounded-lg border py-1.5 pl-3 pr-10 text-left text-xs text-gray-800 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-50 " +
                                (disabled
                                    ? "bg-gray-50 text-gray-400"
                                    : "bg-white") +
                                (widthFull ? " w-full" : " w-auto")
                            }
                        >
                            <span className="flex items-center">
                                {multiple
                                    ? data
                                          ?.filter((x) =>
                                              selected?.includes(x.value)
                                          )
                                          ?.map((y) => y.label)
                                          ?.join(", ")
                                    : data?.find((x) => x?.value === selected)
                                          ?.label}
                            </span>
                            {tooltip && (
                                <Tooltip>
                                    <span className="absolute inset-y-0 right-6 ml-3 flex items-center pr-2">
                                        <TooltipTrigger>
                                            <FontAwesomeIcon
                                                className="h-4 w-4 text-gray-700"
                                                icon={faInfo}
                                            />
                                        </TooltipTrigger>
                                    </span>
                                    <TooltipContent className="Tooltip">
                                        <span className="text-wrap max-w-[20px]">
                                            {" "}
                                            {tooltip}
                                        </span>
                                    </TooltipContent>
                                </Tooltip>
                            )}
                            {disabled !== true && (
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <FontAwesomeIcon
                                        className="h-4 w-4 text-gray-700"
                                        icon={faChevronDown}
                                    />
                                </span>
                            )}
                        </Listbox.Button>
                        <Listbox.Options
                            className={
                                "absolute z-[10000] mt-1 " +
                                (optionsAlwaysVisibles && !forceMaxHeight
                                    ? ""
                                    : "max-h-60") +
                                " ring-black/5 w-full overflow-y-auto overflow-x-hidden rounded-md bg-white py-1 text-base shadow-lg ring-1 focus:outline-none sm:text-sm"
                            }
                        >
                            {data?.map((element, elementId) => {
                                if (element && element?.disabled !== true) {
                                    return (
                                        <Listbox.Option
                                            key={elementId}
                                            disabled={element.value === null}
                                            className={({ active }) =>
                                                `relative cursor-default ${
                                                    element.value === null
                                                        ? "bg-gray-50"
                                                        : ""
                                                } select-none py-2 pl-10 pr-4 ${
                                                    active
                                                        ? "bg-gray-200"
                                                        : "text-gray-900"
                                                }`
                                            }
                                            value={element.value}
                                        >
                                            {({ selected }) => (
                                                <div className="flex flex-row justify-between">
                                                    <span
                                                        className={`block ${
                                                            optionsAlwaysVisibles
                                                                ? ""
                                                                : "truncate"
                                                        } ${
                                                            element.value ===
                                                            null
                                                                ? "bg-gray-50 text-gray-400"
                                                                : ""
                                                        } ${
                                                            selected
                                                                ? "font-medium"
                                                                : "font-normal"
                                                        }`}
                                                    >
                                                        {element.label}
                                                    </span>
                                                    {selected ? (
                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-800">
                                                            <FontAwesomeIcon
                                                                className="h-4 w-4"
                                                                icon={
                                                                    icon
                                                                        ? faUser
                                                                        : faCheck
                                                                }
                                                            />
                                                        </span>
                                                    ) : null}
                                                    {action &&
                                                        (actionIcon ||
                                                            actionIconCalculate) && (
                                                            <span
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    action(
                                                                        element.value
                                                                    );
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    className="h-4 w-4 text-gray-400 hover:text-blue-400"
                                                                    icon={
                                                                        actionIconCalculate
                                                                            ? actionIconCalculate(
                                                                                  element.value
                                                                              )
                                                                            : actionIcon
                                                                    }
                                                                />
                                                            </span>
                                                        )}
                                                </div>
                                            )}
                                        </Listbox.Option>
                                    );
                                }
                            })}
                        </Listbox.Options>
                    </div>
                </div>
            </Listbox>
        </div>
    );
};

const areEqual = (prevProps, nextProps) => {
    const {
        data,
        selected,
        handleSelection,
        description,
        tooltip,
        icon,
        disabled,
        multiple,
        maxSelected,
        action,
        actionIcon,
        actionIconCalculate,
        widthFull,
        optionsAlwaysVisibles,
        warning,
        warningText,
        info,
        infoText,
        forceMaxHeight,
        isIconsList,
    } = nextProps;
    const {
        data: prevData,
        selected: prevSelected,
        handleSelection: prevHandleSelection,
        description: prevDescription,
        tooltip: prevTooltip,
        icon: prevIcon,
        disabled: prevDisabled,
        multiple: prevMultiple,
        maxSelected: prevMaxSelected,
        action: prevAction,
        actionIcon: prevActionIcon,
        actionIconCalculate: prevActionIconCalculate,
        widthFull: prevWidthFull,
        optionsAlwaysVisibles: prevOptionsAlwaysVisibles,
        warning: prevWarning,
        warningText: prevWarningText,
        info: prevInfo,
        infoText: prevInfoText,
        forceMaxHeight: prevForceMaxHeight,
        isIconsList: prevIsIconsList,
    } = prevProps;
    return (
        data === prevData &&
        selected === prevSelected &&
        handleSelection === prevHandleSelection &&
        description === prevDescription &&
        tooltip === prevTooltip &&
        icon === prevIcon &&
        disabled === prevDisabled &&
        multiple === prevMultiple &&
        maxSelected === prevMaxSelected &&
        action === prevAction &&
        actionIcon === prevActionIcon &&
        actionIconCalculate === prevActionIconCalculate &&
        widthFull === prevWidthFull &&
        optionsAlwaysVisibles === prevOptionsAlwaysVisibles &&
        warning === prevWarning &&
        warningText === prevWarningText &&
        info === prevInfo &&
        infoText === prevInfoText &&
        forceMaxHeight === prevForceMaxHeight &&
        isIconsList === prevIsIconsList
    );
};

const MemoizedListBox = React.memo(ListBox, areEqual);

const EasyListBox = ({
    data,
    selected,
    handleSelection,
    description = null,
    tooltip = null,
    icon = false,
    disabled = false,
    multiple = false,
    maxSelected = -1,
    defaultsToCustoms = false,
    action = (payload) => {},
    actionIcon = undefined,
    actionIconCalculate = undefined,
    widthFull = false,
    optionsAlwaysVisibles = false,
    warning = false,
    warningText = "",
    info = false,
    infoText = "",
    forceMaxHeight = false,
    isIconsList = false,
}) => {
    return (
        <MemoizedListBox
            data={data}
            selected={selected}
            handleSelection={handleSelection}
            description={description}
            tooltip={tooltip}
            icon={icon}
            disabled={disabled}
            multiple={multiple}
            maxSelected={maxSelected}
            defaultsToCustoms={defaultsToCustoms}
            action={action}
            actionIcon={actionIcon}
            actionIconCalculate={actionIconCalculate}
            widthFull={widthFull}
            optionsAlwaysVisibles={optionsAlwaysVisibles}
            warning={warning}
            warningText={warningText}
            info={info}
            infoText={infoText}
            forceMaxHeight={forceMaxHeight}
            isIconsList={isIconsList}
        />
    );
};

export default EasyListBox;
